import * as locale from '@adsk/alloy-react-locale';

import useDeprecate from './hooks/useDeprecate';

/**
 * @deprecated Please update to import from @adsk/alloy-react-locale
 */
export const useLocale: typeof locale.useLocale = (...args) => {
  useDeprecate(
    true,
    '@adsk/alloy-react-helpers',
    'useLocale',
    'Please update to import from @adsk/alloy-react-locale',
  );

  return locale.useLocale(...args);
};

/**
 * @deprecated Please update to import from @adsk/alloy-react-locale
 */
export const supportedLocales = locale.supportedLocales;

/**
 * @deprecated Please update to import from @adsk/alloy-react-locale
 */
export const defaultLocale = locale.defaultLocale;

/**
 * @deprecated Please update to import from @adsk/alloy-react-locale
 */
export const LocaleProvider = locale.LocaleProvider;
